import Axios from "axios"

export class PlanSuperScoreService {
  async find(id: string): Promise<PlanSuperScore> {
    return Axios.get(`/api/planSuperScore?planId=${id}`).then(
      response => <PlanSuperScore>response.data
    )
  }
}
